namespace SorAraBul.Administration {
    export interface BuyCreditRequest extends Serenity.ServiceRequest {
        PurchasePackageId?: number;
    }
}
